

// Generated class FilterTicketGroupLine_ManagedObject

class FilterTicketGroupLine_ManagedObject extends MIOManagedObject
{
}
